import { render, staticRenderFns } from "./BusinessSegmentTableItem.vue?vue&type=template&id=06b4713e&"
import script from "./BusinessSegmentTableItem.vue?vue&type=script&lang=js&"
export * from "./BusinessSegmentTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports